import { Constants } from "../../../../common/constants";
import { DashboardUtils, RevertDescriptor } from "../dashboard_utils";
import { EventCreationInputKeys } from "../event_creation";
import { GuildSettingsFormStateKeys } from "../guild_settings/guild_settings";
import { PollCreationInputKeys } from "../poll_creation";
import { ColorPickerForm } from "./color_picker";

export default function EventColorPicker(props: {
	field_key: Extract<
		| EventCreationInputKeys
		| PollCreationInputKeys
		| GuildSettingsFormStateKeys,
		"color" | "default_poll_embed_color" | "default_event_embed_color"
	>;
	color: string;
	disabled?: boolean;
	info: string;
	label: string;
	updateFunc: (value: string) => void;

	revert_descriptor?: RevertDescriptor<string>;
	is_new?: boolean;
}) {
	return (
		<div className="field active">
			{DashboardUtils.CreateHeaderAndInfoButton(
				props.label,
				props.info,
				false,
				false,
				undefined,
				undefined,
				props.disabled,
				props.is_new,
				props.revert_descriptor
			)}
			<ColorPickerForm
				updateFunc={(val) => props.updateFunc(val)}
				value={props.color}
				disabled={props.disabled}
			></ColorPickerForm>
		</div>
	);
}
